import
  React
from 'react';

import {
  useHistory
} from 'react-router-dom';

import {
  Base,
  Text
} from '@vodacom/web-common';

import {
  SecondaryButton
} from 'components';

import {
  CustomColors
} from '../../../constants';

import {
  useRedirectHandler
} from 'helpers';

export const WeatherFooter = props => {

  const history = useHistory();
  const redirectHandler = useRedirectHandler();

  return (
    <>
      <Base
        width={'100%'}
        display={'flex'}
        justifyContent={'center'}>

        <SecondaryButton
          margin={'16px 0 0'}
          width={'90%'}
          text={'See more'}
          onClick={() => {
            const city = props.cities?.find(obj => obj.name === props.city);
            redirectHandler(
              history.location,
              `/redirect?targetUrl=https://openweathermap.org/city/${city?.code}&isZeroRated=false`,
              false
            );
          }}/>

      </Base>

      <Base
        margin={'32px 0 45px 0'}
        display={'flex'}
        justifyContent={'center'}>

        <Text
          whiteSpace={'pre-wrap'}
          fontSize={'16px'}
          color={CustomColors.Grey9}>

          {'Weather forecast by '}

        </Text>

        <Text
          textDecoration={'underline'}
          fontSize={'16px'}
          color={CustomColors.Grey9}
          onClick={() => {
            redirectHandler(
              history.location,
              '/redirect?targetUrl=https://openweathermap.org&isZeroRated=false',
              false
            );
          }}>

          {'OpenWeatherMap'}
        </Text>
      </Base>
    </>
  );
};